__turbopack_context__.v({
  "accent": "Pjag7W_accent",
  "backdrop": "Pjag7W_backdrop",
  "berry-moderate": "Pjag7W_berry-moderate",
  "berry-standard": "Pjag7W_berry-standard",
  "berry-strong": "Pjag7W_berry-strong",
  "berry-subtle": "Pjag7W_berry-subtle",
  "dark": "Pjag7W_dark",
  "dark-scheme": "Pjag7W_dark-scheme",
  "info-strong": "Pjag7W_info-strong",
  "info-subtle": "Pjag7W_info-subtle",
  "inverse": "Pjag7W_inverse",
  "light-scheme": "Pjag7W_light-scheme",
  "moss-moderate": "Pjag7W_moss-moderate",
  "moss-standard": "Pjag7W_moss-standard",
  "moss-strong": "Pjag7W_moss-strong",
  "moss-subtle": "Pjag7W_moss-subtle",
  "smoke-moderate": "Pjag7W_smoke-moderate",
  "smoke-standard": "Pjag7W_smoke-standard",
  "smoke-strong": "Pjag7W_smoke-strong",
  "smoke-subtle": "Pjag7W_smoke-subtle",
  "standard": "Pjag7W_standard",
  "subtle": "Pjag7W_subtle",
  "success-moderate": "Pjag7W_success-moderate",
  "success-strong": "Pjag7W_success-strong",
  "warning-moderate": "Pjag7W_warning-moderate",
  "warning-strong": "Pjag7W_warning-strong",
});
